export const onConnectEnd = (_reactflow) => (_params) => {};
